import css from 'styled-jsx/css';
import { sansSerif } from 'styles/css-constants';
import { MQ_LARGE } from 'constants/mq';

export default css`
  :global(.chicory-button-container) {
    display: flex;
    align-items: center;
  }

  .chicory-order-ingredients {
    padding-bottom: 1.25rem;
  }

  .chicory-order-ingredients :global(a),
  .chicory-order-ingredients :global(button) {
    font-family: ${sansSerif};
  }

  .chicory-order-ingredients :global(a) {
    border-bottom: none;
  }

  .chicory-order-ingredients :global(button) {
    margin: 0 0.5rem 0 0;
    display: block;
    padding: 0.5rem 0.75rem 0.5rem 2rem;
    background-color: transparent;
    /* This is the shopping cart icon */
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 128 128'%3E%3Cpath fill='%23000000' d='M119.9 56c2.1 0 4 .8 5.5 2.3 1.5 1.5 2.4 3.4 2.6 5.8.2 2.4-.6 4.3-2.6 5.8-1.9 1.5-3.8 2.3-5.5 2.3h-1l-7.4 41.1c-.2 1.9-1.1 3.5-2.6 4.8-1.5 1.3-3.2 1.9-5.1 1.9H24.1c-1.9 0-3.6-.6-5.1-1.9-1.5-1.3-2.5-2.9-2.9-4.8L9 72H8c-2.1 0-4.1-.8-5.8-2.3S-.2 66.4 0 64c.2-2.4 1-4.3 2.3-5.8C3.6 56.7 5.5 56 8.1 56h111.8zm-89.6 49.8c1.1 0 2-.4 2.9-1.3.9-.9 1.2-1.8 1-2.9l-2.3-26c0-1.1-.4-1.9-1.3-2.6-.9-.6-1.8-1-2.9-1-1.1 0-1.9.4-2.6 1.3-.6.9-1 1.8-1 2.9l1.9 26c0 1.1.4 1.9 1.3 2.6.9.6 1.7 1 2.6 1h.4zm25.7-3.9v-26c0-1.1-.4-1.9-1.3-2.6s-1.8-1.1-2.9-1.3c-1.1-.2-1.9.2-2.6 1.3s-1.1 1.9-1.3 2.6v26c0 1.1.4 2 1.3 2.9.9.9 1.7 1.2 2.6 1 .9-.2 1.8-.5 2.9-1 1.1-.4 1.5-1.4 1.3-2.9zm23.8 0v-26c0-1.1-.3-1.9-1-2.6-.6-.6-1.6-1.1-2.9-1.3-1.3-.2-2.3.2-2.9 1.3-.6 1.1-1 1.9-1 2.6v26c0 1.1.3 2 1 2.9.6.9 1.6 1.2 2.9 1 1.3-.2 2.3-.5 2.9-1 .6-.4 1-1.4 1-2.9zm22.1.4l1.9-26c0-1.1-.3-2-1-2.9-.6-.9-1.5-1.3-2.6-1.3s-2.1.3-3.2 1c-1.1.6-1.5 1.5-1.3 2.6l-1.9 26c0 1.1.3 2 1 2.9.6.9 1.5 1.3 2.6 1.3h.3c1.1 0 2-.3 2.9-1 .9-.7 1.3-1.6 1.3-2.6zM29.6 26.4l-5.8 25.7h-8l6.1-27.6c.9-3.6 2.8-6.6 5.8-9 3-2.4 6.3-3.5 10-3.5H48c0-1.1.4-1.9 1.3-2.6s1.7-1.1 2.6-1.3H76c1.1 0 2 .4 2.9 1.3.9.9 1.2 1.8 1 2.9h10.6c3.6 0 7 1.1 10 3.2s4.8 5.1 5.5 9l6.4 27.6H104l-5.8-25.7c-.4-1.9-1.4-3.4-2.9-4.5s-3.1-1.7-4.8-1.9H79.8c0 1.1-.3 2-1 2.9-.6.9-1.6 1.3-2.9 1.3H51.8c-1.1 0-1.9-.4-2.6-1.3-.6-.9-1.1-1.9-1.3-2.9H37.6c-1.9 0-3.6.6-5.1 1.9-1.5 1.3-2.5 2.8-2.9 4.5z'/%3E%3C/svg%3E");
    background-position: 0.75rem center;
    background-repeat: no-repeat;
    background-size: 1em auto;
    border: 2px solid #000;
    color: #000;
    font-size: var(--fontScaleNeg2);
    font-weight: bold;
    letter-spacing: 0.02em;
    text-align: center;
    text-transform: uppercase;
    cursor: pointer;
  }

  @media screen and ${MQ_LARGE} {
    .chicory-order-ingredients :global(button) {
      font-size: var(--fontScaleNeg1);
    }
  }
`;
